import React, { useState } from "react";
import obrazek from "../assets/vyrobky/IMG-20260629-WA0017.jpg";

const products = [
  "Kuchyně na míru",
  "Vestavné skříně",
  "Komody",
  "Postele z masivu",
  "Jídelní stoly",
  "Atypické skříňky",
  "Interiérové a vchodové dveře",
  "Zahradní posezení",
  "Dětská hřiště",
  "Dřevěné truhlíky"
];

const partners = [
  {
    name: "Blum",
    description: "Nábytkové kování",
    website: "https://www.blum.com",
    logo: "/assets/logos/Blum%20logo.svg"
  },
  {
    name: "Jaf holz",
    description: "Masivní materiál a deskový materiál",
    website: "https://www.jafholz.cz/",
    logo: "/assets/logos/jaf%20logo.svg"
  },
  {
    name: "Egger",
    description: "Výrobce deskového materiálu",
    website: "https://www.egger.com/cs/",
    logo: "/assets/logos/egger%20logo.svg"
  },
  {
    name: "Icla",
    description: "Povrchové úpravy na dřevo",
    website: "https://www.icla.cz",
    logo: "/assets/logos/icla%20logo.png"
  },
  {
    name: "Blanco",
    description: "Kvalitní německé dřezy",
    website: "https://www.blanco.cz",
    logo: "/assets/logos/blanco%20logo%20-%20blue.svg"
  },
  {
    name: "Okentěs",
    description: "Stavební kování a chemie pro stavbu",
    website: "https://www.okentes.cz/",
    logo: "/assets/logos/okentes%20logo.svg"
  }
];

const About: React.FC = () => {
  const [isImageOpen, setIsImageOpen] = useState(false);

  const openImageModal = (): void => {
    setIsImageOpen(true);
  };

  const closeImageModal = (): void => {
    setIsImageOpen(false);
  };

  return (
    <section className="page-section text-flow">
      <div className="about-intro">
        <button
          type="button"
          className="about-image-trigger"
          onClick={openImageModal}
          aria-label="Zvětšit úvodní fotografii"
        >
          <img
            src={obrazek}
            alt="Ukázka truhlářské práce"
            className="about-top-image"
            loading="lazy"
          />
        </button>

        <p>
          Se dřevem pracuji od dětství a dodnes mě na něm fascinuje jeho přirozená krása,
          pevnost i charakter. Je to materiál, který má duši a dokáže proměnit běžný prostor
          v místo, kde se dobře žije.
        </p>
        <p>
          V oboru mám více než 25 let praxe. Každou zakázku beru osobně, protože za výsledkem
          vždy stojí moje jméno, poctivá ruční práce a odpovědnost za detail.
        </p>
        <p>
          Kromě masivu pracuji také s materiály, které jsou pro moderní výrobu nábytku i
          stavebně truhlářských prvků zásadní, například překližkou, laťovkou, laminem a MDF.
        </p>
      </div>
      <h3>Co pro vás vyrobím</h3>
      <p>
        Specializuji se na zakázkovou výrobu nábytku na míru, atypické skříňky, interiérové
        i vchodové dveře a také venkovní prvky, jako je zahradní posezení nebo dřevěné
        truhlíky. Každý kus navrhuji tak, aby přesně odpovídal prostoru i vašim představám.
      </p>
      <p>
        Na kvalitě si zakládám od prvního zaměření až po finální montáž. Největší odměnou je
        pro mě spokojený zákazník, který se k mému řemeslu rád vrací.
      </p>

      <h3>Můj přístup k práci</h3>
      <p>
        Každý výrobek vzniká jako originál podle prostoru, stylu a potřeb konkrétní domácnosti.
        Od prvního návrhu až po montáž kladu důraz na funkčnost, čisté provedení a dlouhou
        životnost.
      </p>
      <p>Působím převážně ve Středočeském kraji a okolí Prahy.</p>
      <ul className="work-list">
        {products.map((product) => (
          <li key={product}>{product}</li>
        ))}
      </ul>

      <h3>Firmy se kterými spolupracujeme</h3>
      <div className="partners-grid-3">
        {partners.map((partner) => (
          <article key={partner.name} className="partner-box">
            <img src={partner.logo} alt={`${partner.name} logo`} className="partner-box-logo" />
            <h4>{partner.name}</h4>
            <p>{partner.description}</p>
            <a href={partner.website} target="_blank" rel="noreferrer">
              {partner.website}
            </a>
          </article>
        ))}
      </div>

      {isImageOpen && (
        <div className="gallery-modal" role="dialog" aria-modal="true" onClick={closeImageModal}>
          <div className="about-image-modal-content" onClick={(event) => event.stopPropagation()}>
            <img
              src={obrazek}
              alt="Ukázka truhlářské práce"
              className="about-image-full"
            />

            <button
              type="button"
              className="gallery-close"
              onClick={closeImageModal}
              aria-label="Zavřít fotografii"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;
